export default __webpack_public_path__ + "static/media/lightbulb.61d5a440.svg";